import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { User } from "firebase/auth";

export type ServerUser = User;

export type AuthUserStore = {
  firebaseUser: ServerUser | null | false;
  authorized: boolean;
  setFirebaseUser: (user: ServerUser | null | false) => void;
};

export const useAuthUserStore = create(
  persist<AuthUserStore>(
    (set) => ({
      firebaseUser: false,
      authorized: false,
      setFirebaseUser: (firebaseUser) =>
        set(() => ({
          firebaseUser,
          authorized: Boolean(firebaseUser),
        })),
    }),
    {
      name: "auth-user-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
